import { render, staticRenderFns } from "./SidebarNavItem.vue?vue&type=template&id=3d9ab0be&scoped=true&"
import script from "./SidebarNavItem.vue?vue&type=script&lang=js&"
export * from "./SidebarNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNavItem.vue?vue&type=style&index=0&id=3d9ab0be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ab0be",
  null
  
)

export default component.exports